import fetch from "@/fetch";
//查询暂存箱图书列表
export const getStorageBoxBookList = (params) => {
  return fetch({
    method: "post",
    url: "/common/h5/aiidentify/getstorageboxbooklist",
    data: params,
    loading: true,
    actionTypeCode: "56",
    actionTypeDesc: "暂存箱号图书列表查询",
  });
};
